import * as yup from "yup";
import { MultiAddModel, MultiAddSchema } from "../generic";
import { MediaUploadData, MediaUploadSchema } from "../upload";

export interface EventMediaData extends MultiAddModel {
    media: MediaUploadData | null;
    isFloorPlan: boolean;
}

export const EventMediaSchema = yup.object<EventMediaData>().shape({
    ...MultiAddSchema,
    media: MediaUploadSchema.nullable(true).label("Media"),
    isFloorPlan: yup.bool().label("Document is floor plan"),
});

export const DefaultEventMedia: EventMediaData = {
    index: 0,
    isFloorPlan: false,
    isDeleted: false,
    media: null,
};



// WEBPACK FOOTER //
// ./src/forms/adminEvent/EventMedia.ts